<h2>Edit: {{ editDetails?.formTitle }}</h2>
<app-team-edit-details #editDetails></app-team-edit-details>
<mat-dialog-actions>
  <div>
    <button
      mat-flat-button
      color="primary"
      [disabled]="!editDetails.valid || saving"
      (click)="updateTeam()"
    >
      Update
    </button>
    <button type="button" mat-stroked-button (click)="dialogRef.close()">
      Cancel
    </button>
  </div>
</mat-dialog-actions>
